export default String.raw`.category-description__title-container{margin:25px}.category-description__container .description-container{padding:25px}`